import { useMemo } from "react";
import { dictionaryService } from "../../../dataFlow";
import { OLAPTransformerResult, useParameter, useDictionary, Column } from "../../../shared";

const SERIES_AXIS = "attributes.default";
const CATEGORY_AXIS = "calendar.default";
const ATTR_PRICE = 60;
const WEEK_FREQUENCY = 7;

export function useLastPrice(olapData: OLAPTransformerResult | null) {
  const maxPricePoint = useMemo(() => {
    const priceRow = olapData?.rows.find(row => Number(row.selection[SERIES_AXIS]) === ATTR_PRICE);
    const weeksPoints = priceRow?.points.filter(point => {
      const calendarId = String(point.attributes![`${CATEGORY_AXIS}.id`]);
      const frequency = Number(calendarId[0]);
      return WEEK_FREQUENCY === frequency;
    }) || [];
    const lastPoint = weeksPoints[weeksPoints.length - 1];
    return lastPoint;
  }, [olapData]);

  if (maxPricePoint) {
    const priceFormatter = Intl.NumberFormat('en-US', {
      maximumFractionDigits: 0,
    })
    const price = priceFormatter.format(maxPricePoint?.value || 0);

    const [day, month, year] = maxPricePoint?.attributes && maxPricePoint?.attributes[`${CATEGORY_AXIS}.name`]?.split('/') || [];
    const date = new Date([month, day, year].filter(Boolean).join('/'));
    let monthShortName = date.toDateString().split(' ')[1];
    if (Intl?.DateTimeFormat) {
      const formatter = Intl.DateTimeFormat('en-US', {
        month: 'long',
      });
      monthShortName = formatter.format(date);
    }

    return { price, monthShortName };
  }
  return { price: undefined, monthShortName: undefined };
}